import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import cn from 'classnames';

import Badge from 'components/generic/Badge.component';
import Space from 'components/generic/Space.component';
import LINK from 'constants/link.const';
import MENU_READER_STATUS from 'constants/pos/menuReaderStatus.const';
import STRIPE_STATUS from 'constants/pos/stripeStatus.const';
import {
  selectCurrentSalonCalendarMode,
  selectCurrentSalonId,
  selectCurrentSalonReaderStatus,
  selectCurrentSalonStripeStatus,
} from 'selectors/currentSalon.selectors';
import linkTo from 'utils/links/linkTo.util';

import payIcon from '../../assets/images/menu/pay-card.svg';

import CN from './SlickPayLink.module.scss';

const SlickPayLink = ({ salonId, readerStatus, calendarMode, closeMenu, stripeStatus }) => (
  <NavLink
    to={linkTo({
      pattern: LINK.slickPay,
      params: { id: salonId },
      fault: '#',
    })}
    activeClassName="active"
    className={cn(CN.link, CN[calendarMode])}
    onClick={closeMenu}
    data-bem="SlickPayLink"
  >
    <img src={payIcon} alt="" className={CN.menuIcon} />
    {readerStatus === MENU_READER_STATUS.ordered && (
      <>
        <Space>Card reader is on the way!</Space>
        {stripeStatus === STRIPE_STATUS.complete ? (
          <span className={CN.banner}>CONNECT IT HERE</span>
        ) : (
          <span className={cn(CN.banner, CN.warning)}>ACTION REQUIRED</span>
        )}
      </>
    )}

    {(readerStatus === MENU_READER_STATUS.active || readerStatus === MENU_READER_STATUS.deleted) && (
      <>
        <Space>SlickPay Card Reader -</Space>
        <span className={CN.underline}>Check your status!</span>
      </>
    )}

    {(!readerStatus || readerStatus === MENU_READER_STATUS.missing) && (
      <>
        SlickPay Card Reader -
        <div className={CN.gapContainer}>
          <Badge name="New 🚀" variant="menu" />
        </div>
      </>
    )}
  </NavLink>
);

const mapStateToProps = (state) => ({
  salonId: selectCurrentSalonId(state),
  readerStatus: selectCurrentSalonReaderStatus(state),
  stripeStatus: selectCurrentSalonStripeStatus(state),
  calendarMode: selectCurrentSalonCalendarMode(state),
});

// noinspection JSUnusedGlobalSymbols
export default connect(mapStateToProps)(SlickPayLink);
